import React, { useState, useEffect, useMemo, useRef } from 'react';

import { Box, CircularProgress } from '@mui/joy';
import { Text } from '../Typography';
import { Icon } from '../../assets';
import { default as ReactApexChart } from 'react-apexcharts'
import { useDataProvider } from '../../../mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import JSONPretty from 'react-json-pretty';
import { useFormatter } from 'src/mtska-frontend-app-component/utils';
import { calculateWidths, getOptions, getStyles } from './pie.functions';

const Pie = ({ title, dataProviderName, icon, filters, handleFilterChange, mode = 'light', palette = 'palette1', monochrome = { enabled: false }, labelToColorMap, width, legendWidth, donutWidth, height = 230, showTotal = true, showName = true, showValues = true, showLegend = true, format, legendPosition = 'right' }) => {
    const { items, loadAll, loading, success, reloadCounter } = useDataProvider(dataProviderName);
    const [series, setSeries] = useState();
    const [options, setOptions] = useState();
    const { t } = useTranslation();

    const { formatDate, formatCurrency } = useFormatter()

    useEffect(() => {
        if (dataProviderName && !loading && !success) {
            loadAll(filters);
        }
    }, [reloadCounter, filters]);

    const containerRef = useRef(null);
    const [containerWidth, setContainerWidth] = useState(400); // default iniziale

    // Misura la larghezza del container padre
    useEffect(() => {
        if (!containerRef.current) return;

        const resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                setContainerWidth(entry.contentRect.width);
            }
        });

        resizeObserver.observe(containerRef.current);
        return () => resizeObserver.disconnect();
    }, []);

    // Calcola le larghezze effettive
    const widths = useMemo(() => {
        let effectiveWidth;

        if (typeof width === 'number') {
            effectiveWidth = width;
        } else if (typeof width === 'string' && width.includes('%')) {
            const percent = parseFloat(width) / 100;
            effectiveWidth = Math.floor(containerWidth * percent);
        } else {
            // width non specificato = 100% del padre
            effectiveWidth = containerWidth;
        }

        return calculateWidths(effectiveWidth, legendWidth, donutWidth);
    }, [width, legendWidth, donutWidth, containerWidth]);

    console.info('PIE', title, width, widths);
    
    useEffect(() => {
        getOptions(items, monochrome, showLegend, widths, width, height, mode, palette, showTotal, showName, showValues, labelToColorMap, setSeries, setOptions, t, handleFilterChange, legendPosition)
    }, [items])


    return (
        (!series || !options) ? <CircularProgress /> :
            <Box ref={containerRef} className="mtska-chart mtska-chart-pie">
                <Icon icon={icon} family="fal"></Icon>
                <Text level="title-sm" className="title">{title}</Text>
                <Box className="chartwrapper" sx={getStyles(height)}>
                    {
                        loading ? <CircularProgress /> :

                            <ReactApexChart
                                type="donut"
                                options={options}
                                series={series}
                                height={height}
                                width={width}
                            />
                    }
                </Box>
            </Box>
    );
}

export default Pie;
//style={width == 200 ? {} : {minHeight:'40px',verticalAlign:'top',display:'block'}}